import React from 'react';


export default class DpcCarousel extends React.Component {

    constructor(props) {
        super(props);

    }

    render() {
        return (
            <></>

        )
    }

}
